import { render } from "./TestSlider.vue.vue?vue&type=template&id=0187ddd8"
import script from "./TestSlider.vue.vue?vue&type=script&lang=js"
export * from "./TestSlider.vue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__